import { Login } from 'react-admin';
import PasswordResetForm from './PasswordResetForm'

const PasswordReset = () => (
  <Login backgroundImage="splashScreen.jpg">
    <PasswordResetForm />
  </Login>
)

export default PasswordReset;